import { OfferScreen } from 'app/features/offer/screens'
import { fetchOfferQuery } from 'app/features/offer/screens/offer-screen/queries'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page(props: any) {
  return <OfferScreen {...props} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async ({ params, query: q, req }) => {
    const user = req?.session?.user
    const draft = !!q?.preview

    const client = initializeApollo({
      token: user?.token,
      previewToken: q?.token as string,
    })

    await client.query({
      query: fetchOfferQuery,
      variables: {
        slug: params?.slug,
        draft,
      },
    })

    return addApolloState(client, {
      props: {
        user: user || null,
        preview: draft,
      },
    })
  }
)
